import React, { useState } from 'react';
import { Grid, Calendar, Shield, MessageSquare, CreditCard, Menu, FileText, Heart } from 'lucide-react';

/**
 * Navigation mobile bottom bar (iOS/Android style)
 * Affiche les 5 onglets principaux + menu pour les autres
 */
const ClientMobileNav = ({ activeTab, onTabChange, unreadCount = 0, overdueInvoices = 0 }) => {
  const [showMoreMenu, setShowMoreMenu] = useState(false);

  const tabs = [
    {
      id: 'dashboard',
      icon: Grid,
      label: 'Accueil',
      badge: null,
    },
    {
      id: 'calendar',
      icon: Calendar,
      label: 'Planning',
      badge: null,
    },
    {
      id: 'messaging',
      icon: MessageSquare,
      label: 'Messages',
      badge: unreadCount > 0 ? unreadCount : null,
    },
    {
      id: 'billing',
      icon: CreditCard,
      label: 'Factures',
      badge: overdueInvoices > 0 ? overdueInvoices : null,
      badgeColor: overdueInvoices > 0 ? 'bg-red-500' : 'bg-blue-500',
    },
    {
      id: 'more',
      icon: Menu,
      label: 'Plus',
      badge: null,
    },
  ];

  const moreMenuItems = [
    {
      id: 'documents',
      icon: FileText,
      label: 'Mes documents',
    },
    {
      id: 'personal-info',
      icon: Shield,
      label: 'Mes informations',
    },
    {
      id: 'medical-info',
      icon: Heart,
      label: 'Info. médicales',
    },
  ];

  const handleTabClick = (tabId) => {
    if (tabId === 'more') {
      setShowMoreMenu(!showMoreMenu);
    } else {
      onTabChange(tabId);
      setShowMoreMenu(false);
    }
  };

  const handleMoreMenuItemClick = (itemId) => {
    onTabChange(itemId);
    setShowMoreMenu(false);
  };

  return (
    <>

      {/* Menu "Plus" */}
      {showMoreMenu && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-30 md:hidden"
          onClick={() => setShowMoreMenu(false)}
        >
          <div
            className="absolute bottom-16 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            {moreMenuItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeTab === item.id;

              return (
                <button
                  key={item.id}
                  onClick={() => handleMoreMenuItemClick(item.id)}
                  className={`flex items-center w-full px-6 py-4 space-x-4 transition-colors ${isActive
                    ? 'bg-blue-50 dark:bg-blue-900 text-blue-600 dark:text-blue-400'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                    }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="text-sm font-medium">{item.label}</span>
                  {isActive && (
                    <span className="ml-auto text-blue-600 dark:text-blue-400">✓</span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Bottom Navigation Bar - Fixed at the absolute bottom of the viewport */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-[0_-8px_15px_-3px_rgba(0,0,0,0.05)] md:hidden pb-[env(safe-area-inset-bottom,0)]">
        <div className="flex items-center justify-around h-16 px-2">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id || (tab.id === 'more' && moreMenuItems.some(item => item.id === activeTab));

            return (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`relative flex flex-col items-center justify-center flex-1 h-full space-y-1 transition-colors ${isActive
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-600 dark:text-gray-400'
                  }`}
              >
                <div className="relative">
                  <Icon
                    className={`w-6 h-6 transition-transform ${isActive ? 'scale-110' : 'scale-100'
                      }`}
                  />
                  {tab.badge !== null && (
                    <span className={`absolute -top-2 -right-2 ${tab.badgeColor || 'bg-red-500'} text-white text-xs font-bold rounded-full h-5 min-w-[20px] flex items-center justify-center px-1`}>
                      {tab.badge > 9 ? '9+' : tab.badge}
                    </span>
                  )}
                </div>
                <span className={`text-[10px] font-medium ${isActive ? 'font-semibold' : ''}`}>
                  {tab.label}
                </span>
                {isActive && (
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-blue-600 dark:bg-blue-400 rounded-t-full" />
                )}
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default ClientMobileNav;
